import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class ServiceChargeService {
	/**
	 * This functions are used for Ratings related tasks.
	 * @return {}
	 */

	static async getList() {
		return ApiService.GetData(`${API_URLS.GET_LIST_SERVICE_CHARGE}`, 'servicecharge');
	}

	static async delete(id) {
		return ApiService.DeleteData(`${API_URLS.REMOVE_SERVICE_CHARGE}/${id}`, 'servicecharge');
	}

	static async update(id, payload) {
		return ApiService.PatchData(`${API_URLS.UPDATE_SERVICE_CHARGE}/${id}`, payload, 'servicecharge');
	}

	static async add(payload) {
		return ApiService.PostData(`${API_URLS.ADD_SERVICE_CHARGE}`, payload, 'servicecharge');
	}
}
